import React, { FC, useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams, useRouteMatch, useHistory } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';

import { Dispatch, iRootState } from '../../../../store';
import { paths } from '../../../../routes/Root/paths';
import { useAsync } from '../../../../hooks';

import Content from '../../../../components_/Content';
import Spinner from '../../../../components_/Spinner';
import EmptyState from '../../../../components_/EmptyState';

import Form from './Form';
import FormAdd from './FormAdd';
import FormActions from './FormActions';

interface IParams {
  id: string;
}

const mapState = (state: iRootState) => ({
  data: state.equipmentProtections.data,
  forms: state.equipmentProtections.forms,
  item: state.equipmentProtections.item
});

const mapDispatch = (dispatch: any) => {
  const d = dispatch as Dispatch;

  return {
    getData: d.equipmentProtections.getData,
    getItem: d.equipmentProtections.getItem,
    addForm: d.equipmentProtections.addForm,
    deleteForm: d.equipmentProtections.deleteForm,
    editForm: d.equipmentProtections.editForm,
    setSubmitForms: d.equipmentProtections.setSubmitForms,
    updateOrCreate: d.equipmentProtections.updateOrCreate
  };
};

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;

export type IProps = connectedProps;

const Index: FC<IProps> = ({
  data,
  forms,
  item,
  getData,
  getItem,
  addForm,
  deleteForm,
  editForm,
  setSubmitForms,
  updateOrCreate
}) => {
  const { list: formList, isSubmit } = forms;

  const [runGetData, isLoadingGetData, isGetDataLoadingError] = useAsync(getData, true);
  const [runGetItem, isLoadingGetItem, isGetItemLoadingError] = useAsync(getItem);
  const [runUpdateOrCreate, isLoadingUpdateOrCreate, isUpdateOrCreateLoadingError] = useAsync(
    updateOrCreate
  );
  const { id } = useParams<IParams>();
  const history = useHistory();
  const isCreate = Boolean(useRouteMatch(paths.equipment.protections.create));
  const isEdit = Boolean(useRouteMatch(paths.equipment.protections.edit()));
  const isCopy = Boolean(useRouteMatch(paths.equipment.protections.copy()));

  useEffect(() => {
    runGetData();

    if (isEdit || isCopy) {
      runGetItem(id);
    }
  }, []);

  const handleCancel = () => {
    history.goBack();
  };

  const isLoading = isLoadingGetData || isLoadingGetItem;
  const isLoadingError = isGetDataLoadingError || isGetItemLoadingError;

  const title = isCreate
    ? 'Добавить СИЗ'
    : isCopy
    ? 'Копировать СИЗ'
    : isEdit && item
    ? item.number
    : '';

  return (
    <Content
      breadcrumb={[
        { name: 'Оборудование', url: paths.equipment.protections.root },
        { name: title }
      ]}
      title={title}
    >
      {!isLoading && !isLoadingError && (
        <Grid item xs container direction="column" justify="space-between">
          <Grid>
            {formList.map((formItem, index) => (
              <Form
                key={formItem.uid}
                index={index}
                form={formItem}
                data={data}
                item={item}
                isCreate={isCreate}
                isEdit={isEdit}
                isCopy={isCopy}
                isSubmit={isSubmit}
                deleteForm={deleteForm}
                editForm={editForm}
                setSubmitForms={setSubmitForms}
                onSubmitAction={runUpdateOrCreate}
                onCancel={handleCancel}
              />
            ))}
            {isCreate && <FormAdd addForm={addForm} />}
          </Grid>
          <FormActions
            forms={forms}
            isEdit={isEdit}
            setSubmitForms={setSubmitForms}
            onCancel={handleCancel}
          />
        </Grid>
      )}
      {isLoading && <Spinner />}
      {isLoadingError && <EmptyState variant="serverError" />}
    </Content>
  );
};

const withConnect = connect(mapState, mapDispatch);

export default withConnect(Index);
